





import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import Dialog from '@/components/dialog.vue';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class CollectionRecords extends Vue {
  mounted() {}
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  visible: boolean = false;
  pageData: any = {
    url: '/back/v1/log/user/search',
    isFirst: true,
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      number: '',
      page_index: 1,
      page_num: 10
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'number', // 字段
        tip: '手机号码',
        placeholder: '请输入手机号码'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '导出日志',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: false,
      border: true,
      expandShow: false,
      optionShow: false,
      tableRowClassName: function(tableData: any) {
        if (tableData.row.card_status === 3) {
          return 'success3-row';
        }
        return '';
      },
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID',
        //   width: '70'
        // },
        {
          prop: 'Number',
          label: '手机号码'
        },
        {
          prop: 'Account',
          label: '账号'
        },
        {
          prop: 'Message',
          label: '内容'
        },
        {
          prop: 'IPAddr',
          label: 'IP'
        },
        {
          prop: 'ReadAt',
          label: '时间',
          type: 'time'
        }
      ],
      expand: [],
      optionWidth: 100,
      option: []
    } // table
  };
  private handleClick(methods: string, row: any) {}
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
}
